var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasTodayList)?_c('div',{staticClass:"home"},[(_vm.isDoneAll)?_c('todo-done'):_c('todo-start')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }